import { useEffect, useState } from 'react';
import { NetworkStatus } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { otherWorklflowsTriggeringCurrentWorkflowQuery } from 'api/queries/workflowNodeEditors';
import { Workflow } from 'modules/workflows/types';

type OtherWorkflow = { workflow: { id: number; name: string } };
type OtherWorkflowsTriggeringCurrentWorkflowQueryResponse = {
  workflow: { allTriggeredByWorkflows: OtherWorkflow[] };
};

const parseData = (workflows: OtherWorkflow[] = []) =>
  (workflows.map(({ workflow }) => workflow) || []) as Workflow[];

/**
 * Fetches list of workflows that trigger current workflow
 * @param {number} id - workflow ID
 * @param {workflowType} - draft or published
 * @returns {object} An object containing workflowsTriggeringCurrentWorkflow[], networkStatus, error
 */
export const useOtherWorkflowsTriggeringCurrentWorkflow = ({ id, workflowType }: Workflow) => {
  const {
    data,
    errorMessage: error,
    networkStatus,
  } = useGraphql<OtherWorkflowsTriggeringCurrentWorkflowQueryResponse>(
    otherWorklflowsTriggeringCurrentWorkflowQuery,
    { variables: { id, workflowType }, fetchPolicy: 'network-only' },
  );
  const [otherWorkflows, setOtherWorkflows] = useState<Workflow[]>([]);

  useEffect(() => {
    if (networkStatus === NetworkStatus.ready) {
      const workflows = parseData(data?.workflow?.allTriggeredByWorkflows);
      setOtherWorkflows(workflows);
    }
  }, [networkStatus, data]);

  return {
    workflowsTriggeringCurrentWorkflow: otherWorkflows,
    networkStatus,
    error,
  };
};
